export default {
    isLoading: false,
    user: null,
    errorMessage: null,
}